module.exports = __webpack_public_path__ + "static/media/keyboard-arrow-down-white.a31fec88.svg";